import {
  LIST_MESSAGE_STATUS_REQUEST,
  LIST_MESSAGE_STATUS_SUCCESS,
  LIST_MESSAGE_STATUS_FAIL,
  LIST_PRODUCT_REQUEST,
  LIST_PRODUCT_SUCCESS,
  LIST_PRODUCT_FAIL,
  LIST_PRODUCT_SUMMARY_REQUEST,
  LIST_PRODUCT_SUMMARY_SUCCESS,
  LIST_PRODUCT_SUMMARY_FAIL,
  LIST_PAYMENT_OPTION_REQUEST,
  LIST_PAYMENT_OPTION_SUCCESS,
  LIST_PAYMENT_OPTION_FAIL
} from '../../constants/others'

const initialState = {
  loading: false,
  loadingSummaryProduct: false,
  messageStatus: [],
  products: [],
  productSummary: [],
  paymentOptions: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const othersReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MESSAGE_STATUS_REQUEST:
      return { ...state, loading: true }
    case LIST_MESSAGE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        messageStatus: action.payload
      }
    case LIST_MESSAGE_STATUS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_PRODUCT_REQUEST:
      return { ...state, loading: true }
    case LIST_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload,
        pageable: action.pageable
      }
    case LIST_PRODUCT_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_PRODUCT_SUMMARY_REQUEST:
      return { ...state, loadingSummaryProduct: true }
    case LIST_PRODUCT_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingSummaryProduct: false,
        productSummary: action.payload
      }
    case LIST_PRODUCT_SUMMARY_FAIL:
      return { ...state, loadingSummaryProduct: false, error: action.payload, productSummary: action?.dummy }
    case LIST_PAYMENT_OPTION_REQUEST:
      return { ...state, loading: true }
    case LIST_PAYMENT_OPTION_SUCCESS:
      return { ...state, loading: false, paymentOptions: action.payload, pageable: action.pageable }
    case LIST_PAYMENT_OPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        paymentOptions: action?.dummy
      }
    default:
      return state
  }
}

export default othersReducer
